"use strict";
var _ = require("lodash");
var $ = require("jquery");
/** Утилита для экспорта книг */
var ExportBookUtils = (function () {
    function ExportBookUtils() {
    }
    /** Закрывает окно со списком форматов книг для скачивания */
    ExportBookUtils.closePopup = function () {
        var popover = $("#popoverDownloads")[0];
        app.f7.closeModal(popover);
    };
    return ExportBookUtils;
}());
_.extend(window["AppUtils"], {
    ExportBook: ExportBookUtils
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ExportBookUtils;
//# sourceMappingURL=exportBookUtils.js.map